import { Link } from "react-router-dom";

const h2 = "text-xl md:text-2xl font-semibold text-gray-900 mt-10 mb-3";
const p = "text-base leading-relaxed mb-6";
const a = "underline hover:text-gray-600";

const ConditionsUtilisationPage = () => (
  <div className="bg-white">
    <div className="container mx-auto px-4 py-12 md:py-20">
      <div className="max-w-3xl mx-auto text-gray-800">
        <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
          Conditions d’utilisation
        </h1>
        <p className="text-sm text-gray-500 mb-8">
          <strong>Dernière mise à jour : 4 novembre 2026</strong>
        </p>

        <p className={p}>
          Les présentes conditions encadrent l’utilisation du site gssanaa.com et des contenus
          publiés par le Groupe Scolaire Sanaa («&nbsp;GSS&nbsp;», «&nbsp;nous&nbsp;») sur ses
          comptes officiels. En consultant le site, vous acceptez ces conditions.
        </p>

        <h2 className={h2}>1. Éditeur</h2>
        <p className={p}>
          Institution Sanaa<br />
          <span className="text-gray-600">(exploitant le Groupe Scolaire Sanaa)</span><br />
          364 boulevard Oum Rabia, Oulfa, Casablanca, 20220, Maroc<br />
          Téléphone : <a href="tel:0522908238" className={a}>0522908238</a><br />
          Email : <a href="mailto:info@gssanaa.com" className={a}>info@gssanaa.com</a>
        </p>

        <h2 className={h2}>2. Objet du site</h2>
        <p className={p}>
          Le site présente l’école, ses cycles, sa vie scolaire et ses actualités. Il permet aussi
          aux familles de nous contacter et de demander une visite. Les informations publiées sont
          données à titre indicatif : seuls les documents remis par l’administration de l’école
          font foi, notamment pour les inscriptions et les tarifs.
        </p>

        <h2 className={h2}>3. Utilisation du site</h2>
        <p className={p}>
          Vous vous engagez à utiliser le site de façon loyale, à transmettre des informations
          exactes dans les formulaires et à ne pas perturber son fonctionnement. L’accès peut être
          interrompu, notamment pour maintenance, sans que cela ouvre droit à une indemnité.
        </p>

        <h2 className={h2}>4. Propriété intellectuelle</h2>
        <p className={p}>
          Les textes, photos, vidéos, logos et autres éléments du site et de nos comptes officiels
          appartiennent au GSS ou à leurs auteurs. Toute reproduction ou réutilisation sans notre
          accord écrit est interdite, sauf le partage des publications avec les outils prévus par
          les réseaux sociaux.
        </p>

        <h2 className={h2}>5. Réseaux sociaux</h2>
        <p className={p}>
          Le GSS publie ses actualités sur ses comptes officiels, notamment Facebook, Instagram,
          YouTube, LinkedIn et TikTok. Ces publications sont préparées et programmées par notre
          équipe avec un outil interne de gestion, utilisé uniquement pour les comptes de l’école.
          L’utilisation de ces plateformes reste soumise à leurs propres conditions.
        </p>
        <p className={p}>
          Pour demander le retrait d’une publication vous concernant ou concernant votre enfant,
          écrivez à <a href="mailto:info@gssanaa.com" className={a}>info@gssanaa.com</a>.
        </p>

        <h2 className={h2}>6. Données personnelles</h2>
        <p className={p}>
          Le traitement de vos données est décrit dans notre{" "}
          <Link to="/politique-confidentialite" className={a}>politique de confidentialité</Link>.
        </p>

        <h2 className={h2}>7. Liens externes et responsabilité</h2>
        <p className={p}>
          Le site peut contenir des liens vers des sites tiers, dont nous ne contrôlons pas le
          contenu. Nous veillons à l’exactitude des informations publiées, sans pouvoir garantir
          qu’elles soient complètes ou à jour en permanence.
        </p>

        <h2 className={h2}>8. Droit applicable</h2>
        <p className={p}>
          Les présentes conditions sont soumises au droit marocain. En cas de litige, nous
          recherchons d’abord une solution amiable ; à défaut, les tribunaux compétents de
          Casablanca sont saisis.
        </p>

        <h2 className={h2}>9. Modifications</h2>
        <p className={p}>
          Ces conditions peuvent évoluer. La date de dernière mise à jour figure en haut de la
          page.
        </p>

        <h2 className={h2}>10. Contact</h2>
        <ul className="list-disc pl-6 space-y-2 mb-6 text-base leading-relaxed">
          <li>Email : <a href="mailto:info@gssanaa.com" className={a}>info@gssanaa.com</a></li>
          <li>Téléphone : <a href="tel:0522908238" className={a}>0522908238</a></li>
          <li>Adresse : 364 boulevard Oum Rabia, Oulfa, Casablanca, 20220</li>
        </ul>
      </div>
    </div>
  </div>
);

export default ConditionsUtilisationPage;
